export default __webpack_public_path__ + "static/media/stegosaurus.0b6e5688.png";